<app-nav-menu></app-nav-menu>
<main class="main">
  @if (!isUnited) {
    <div id="nav-tab-card" class="container" >
      <h3 class="text-dark text-center my-5">Search Booked Plans</h3>
      <form role="form" (ngSubmit)="SearchBookedPlans(planSearchForm)" #planSearchForm="ngForm">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden for="fromow">BOOKING STATUS</label>
              <input type="text" name="bookingstatus" placeholder="Booked/Cancelled" ngModel hidden #bookingstatus="ngModel" class="form-control">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden for="goingtoow">CERTIFICATE NO.</label>
              <div class="input-group">
                <input type="text" name="certificateno" class="form-control" ngModel hidden #certificateno="ngModel">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3"></div>
          <div class="col-6">
            <div class="form-group">
              <label for="goingtoow">PNR/IDENTIFICATION CODE</label>
              <div class="input-group">
                <input type="text" name="pnr" class="form-control" ngModel #pnr="ngModel" required>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label hidden for="fromow">PLAN CODE</label>
              <input type="text" name="plancode" ngModel #plancode="ngModel" hidden class="form-control">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden><span class="hidden-xs">BOOKING AGENT USER NAME</span></label>
              <div class="input-group">
                <input type="text" name="bagentusername" class="form-control" hidden ngModel #bagentusername="ngModel">
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-4">
              <label hidden>TRAVELER FULL NAME</label>
              <input type="text" name="tfullname" ngModel #tfullname="ngModel" hidden class="form-control">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden for="fromow">DEPARTURE COUNTRY</label>
              <input type="text" name="departurecountry" ngModel hidden #departurecountry="ngModel" class="form-control">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden for="goingtoow">ARRIVAL COUNTRY</label>
              <div class="input-group">
                <input type="text" name="arrivalcountry" class="form-control" ngModel #arrivalcountry="ngModel" hidden>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden for="fromow">DEPARTURE DATE (FROM)</label>
              <input type="text" name="departuredatefrom" ngModel hidden #departuredatefrom="ngModel" class="form-control">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden for="goingtoow">DEPARTURE DATE (TO)</label>
              <div class="input-group">
                <input type="text" name="departuredateto" class="form-control" ngModel #departuredateto="ngModel" hidden>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden for="fromow">BOOKING PERIOD (FROM)</label>
              <input type="text" name="bookingperiodfrom" ngModel hidden #bookingperiodfrom="ngModel" class="form-control">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label hidden for="goingtoow">BOOKING PERIOD (TO)</label>
              <div class="input-group">
                <input type="text" name="bookingperiodto" class="form-control" ngModel #bookingperiodto="ngModel" hidden>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row mt-3">
          <div class="col-lg-3 col-md-3 col-sm-12 mb-1">
            <button type="button" class="subscribe btn btn-block shadow-sm text-uppercase" (click)="ToDashboard()"><i class="fas fa-angle-double-left"></i> Dashboard  </button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 mb-1">
            <button type="submit" [disabled]="!planSearchForm.valid" class="subscribe btn btn-block shadow-sm text-uppercase"> Search <i class="fas fa-angle-double-right"></i> </button>
          </div>
        </div>
      </form>
    </div>
  }
  @if (isUnited) {
    <div class="container">
      <h3 class="text-dark text-center my-5">Search Booked Plans</h3>
      <form role="form" (ngSubmit)="SearchBookedPlansUnited(uplanSearchForm)" #uplanSearchForm="ngForm">
        <div class="row"></div>
        <div class="row">
          <div class="col-3"></div>
          <div class="col-6">
            <div class="form-group">
              <label for="goingtoow">POLICY NO.</label>
              <div class="input-group">
                <input type="text" name="policyNo" class="form-control" ngModel #policyNo="ngModel" required>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label hidden for="fromow">REQUEST ID</label>
              <input type="text" name="plancode" ngModel #requestID="ngModel" hidden class="form-control">
            </div>
          </div>
        </div>
        <div class="row"></div>
        <hr />
        <div class="row mt-3">
          <div class="col-lg-3 col-md-3 col-sm-12 mb-1">
            <button type="button" class="subscribe btn btn-block shadow-sm text-uppercase" (click)="ToDashboard()"><i class="fas fa-angle-double-left"></i> Dashboard  </button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 mb-1">
            <button type="submit" [disabled]="!uplanSearchForm.valid" class="subscribe btn btn-block shadow-sm text-uppercase"> Search <i class="fas fa-angle-double-right"></i> </button>
          </div>
        </div>
      </form>
    </div>
  }
  @if (showPolicy) {
    <div class="container-fluid cms_main fadeInUp animated">
      <div class="inner_body">
        <div class="row cms_tabel">
          <div class="col-sm-12 table-responsive">
            <table class="table" style="width:max-content">
              <thead class="">
                <tr>
                  <th scope="col">No. Of Passengers</th>
                  <th scope="col">Plan Title</th>
                  <th scope="col">Itinerary ID</th>
                  <th scope="col">Policy No.</th>
                  <th scope="col">PNR</th>
                  <!--<th scope="col">Fly Date</th>-->
                  <th scope="col">Purchased Date</th>
                  <!--<th scope="col">Premium Amount</th>-->
                  <th scope="col">Proposal State</th>
                  <th scope="col">Total Premium Amount</th>
                  <!--<th scope="col">Taxes</th>
                  <th scope="col">Service Fee</th>
                  <th scope="col">Discount</th>-->
                  <th scope="col">Passengers Info.</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{baseData.purchaseInformation.noOfPassengers}}</td>
                  <td>{{baseData.purchaseInformation.planTitle}}</td>
                  <td>{{baseData.purchaseInformation.itineraryID}}</td>
                  <td>{{baseData.purchaseInformation.policyNo}}</td>
                  <td>{{baseData.purchaseInformation.pnr}}</td>
                  <td>{{baseData.purchaseInformation.policyPurchasedFlyDate}}</td>
                  <!--<td>{{baseData.purchaseInformation.policyPurchasedDateTime}}</td>-->
                  <!--<td>{{baseData.purchaseInformation.premiumAmount}}</td>-->
                  <td>{{baseData.purchaseInformation.proposalState}}</td>
                  <td>{{baseData.purchaseInformation.totalRevenuePremium}}</td>
                  <!--<td>{{baseData.purchaseInformation.vat}}</td>
                  <td>{{baseData.purchaseInformation.serviceFee}}</td>
                  <td>{{baseData.purchaseInformation.discount}}</td>-->
                  <td><button class="btn btn-link" (click)="openTraveler(sweet)"><i class="uil uil-clipboard-alt action-class mr-1"></i>More Info</button></td>
                </tr>
              </tbody>
            </table>
            <div>
              <ng-template #sweet let-modal>
                <div class="modal-success">
                  <button class="btn btn-close mb-3 float-end" (click)="modal.dismiss()">X</button>
                  <h2 class="text-center mb-4">Confirmed Passengers</h2>
                  <div class="container-fluid">
                    <table class="table">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">Passenger Name</th>
                          <th scope="col">Date of Birth</th>
                          <th scope="col">Identity No.</th>
                          <th scope="col">Policy No.</th>
                          <th scope="col">Policy Link</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (pax of baseData.confirmedPassengers; track pax) {
                          <tr>
                            <td>{{pax.firstName}}</td>
                            <td>{{pax.dob.split(" ")[0]}}</td>
                            <td>{{pax.identityNo}}</td>
                            <td>{{pax.policyNo}}</td>
                            <td><a href="{{pax.policyURLLink}}" target="_blank">View Policy</a></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (showUnitedPolicy) {
    <div class="container-fluid cms_main fadeInUp animated">
      <div class="inner_body">
        <div class="row cms_tabel">
          <div class="col-sm-12 table-responsive">
            <table class="table" style="width:max-content">
              <thead class="">
                <tr>
                  <th scope="col">No. Of Passengers</th>
                  <th scope="col">No. Of Days</th>
                  <th scope="col">Plan Title</th>
                  <th scope="col">Plan Type</th>
                  <th scope="col">Policy No.</th>
                  <th scope="col">Coverage Area</th>
                  <!--<th scope="col">Fly Date</th>-->
                  <th scope="col">Purchased Date</th>
                  <!--<th scope="col">Premium Amount</th>-->
                  <th scope="col">Total Premium Amount</th>
                  <th scope="col">Status</th>
                  <!--<th scope="col">Taxes</th>
                  <th scope="col">Service Fee</th>
                  <th scope="col">Discount</th>-->
                  <th scope="col">Passengers Info.</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{unitedBaseData.noOfPassengers}}</td>
                  <td>{{unitedBaseData.noOfDays}}</td>
                  <td>{{unitedBaseData.plan}}</td>
                  <td>{{unitedBaseData.planType}}</td>
                  <td>{{unitedBaseData.policyNo}}</td>
                  <td>{{unitedBaseData.areaShortCode}}</td>
                  <td>{{unitedBaseData.policyPurchaseDate}}</td>
                  <!--<td>{{baseData.policyPurchasedDateTime}}</td>-->
                  <!--<td>{{baseData.premiumAmount}}</td>-->
                  <td>{{unitedBaseData.totalRevenuePremium}}</td>
                  <td>{{unitedBaseData.isCancelled ? "Cancelled" : "Booked"}}</td>
                  <!--<td>{{baseData.vat}}</td>
                  <td>{{baseData.serviceFee}}</td>
                  <td>{{baseData.discount}}</td>-->
                  <td><button class="btn btn-link" (click)="openTravelerUnited(sweetUnited)"><i class="uil uil-clipboard-alt action-class mr-1"></i>More Info</button></td>
                </tr>
              </tbody>
            </table>
            <div>
              <ng-template #sweetUnited let-modal>
                <div class="modal-success">
                  <button class="btn btn-close mb-3 float-end" (click)="modal.dismiss()">X</button>
                  <h2 class="text-center mb-4">Confirmed Passengers</h2>
                  <div class="container-fluid">
                    <table class="table">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">Passenger Name</th>
                          <th scope="col">Date of Birth</th>
                          <th scope="col">Identity No.</th>
                          <th scope="col">Contact No.</th>
                          <th scope="col">Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{unitedBaseData.principalTraveller.fullName}}</td>
                          <td>{{unitedBaseData.principalTraveller.dob}}</td>
                          <td>{{unitedBaseData.principalTraveller.passportNo}}</td>
                          <td>{{unitedBaseData.principalTraveller.contactNo}}</td>
                          <td>{{unitedBaseData.principalTraveller.address}}</td>
                        </tr>
                        <tr>
                          <td>{{unitedBaseData.principalTraveller.beneficiaryName}} ({{unitedBaseData.principalTraveller.relation}})</td>
                          <td>---</td>
                          <td>---</td>
                          <td>{{unitedBaseData.principalTraveller.beneficiaryPhone}}</td>
                          <td>{{unitedBaseData.principalTraveller.beneficiaryAddress}}</td>
                        </tr>
                        @if (unitedBaseData.isSpousePresent) {
                          <tr>
                            <td>{{unitedBaseData.principalTraveller.spouseName}}</td>
                            <td>{{unitedBaseData.principalTraveller.spouseDOB}}</td>
                            <td>{{unitedBaseData.principalTraveller.spousePassport}}</td>
                            <td>---</td>
                            <td>---</td>
                          </tr>
                        }
                        @if (unitedBaseData.principalTraveller.child1Passport != '' && unitedBaseData.principalTraveller.child1Passport != null) {
                          <tr>
                            <td>{{unitedBaseData.principalTraveller.child1Name}}</td>
                            <td>{{unitedBaseData.principalTraveller.child1DOB}}</td>
                            <td>{{unitedBaseData.principalTraveller.child1Passport}}</td>
                            <td>---</td>
                            <td>---</td>
                          </tr>
                        }
                        @if (unitedBaseData.principalTraveller.child2Passport != '' && unitedBaseData.principalTraveller.child2Passport != null) {
                          <tr>
                            <td>{{unitedBaseData.principalTraveller.child2Name}}</td>
                            <td>{{unitedBaseData.principalTraveller.child2DOB}}</td>
                            <td>{{unitedBaseData.principalTraveller.child2Passport}}</td>
                            <td>---</td>
                            <td>---</td>
                          </tr>
                        }
                        @if (unitedBaseData.principalTraveller.child3Passport != '' && unitedBaseData.principalTraveller.child3Passport != null) {
                          <tr>
                            <td>{{unitedBaseData.principalTraveller.child3Name}}</td>
                            <td>{{unitedBaseData.principalTraveller.child3DOB}}</td>
                            <td>{{unitedBaseData.principalTraveller.child3Passport}}</td>
                            <td>---</td>
                            <td>---</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</main>
